import { getDictionary, loginValidate, logout, checkToken } from '@/http/api'

const state = {
  baseMts: [],
  baseTwinslatorMts: [],
  industryTreeList: [],
  languageInfoList: [],
  userInfo: {},
  token: '',
  iolcode: '',
  autoPay: true,
  translateMode: true,
}
const getters = {
  accessToken: (state) => state.token,
}
const mutations = {
  changeKey(state, payload) {
    for (let i in payload) {
      state[i] = null
      state[i] = payload[i]
    }
  },
}
const actions = {
  // 获取全局参数
  getDictionary({ commit }) {
    getDictionary().then(({ data }) => {
      const _data = data.data
      commit('changeKey', {
        baseMts: _data.baseMts,
        baseTwinslatorMts: _data.baseTwinslatorMts,
        industryTreeList: _data.industryTreeList,
        languageInfoList: _data.languageInfoList,
      })
      localStorage.industryTreeList = JSON.stringify(_data.industryTreeList)
      localStorage.languageInfoList = JSON.stringify(_data.languageInfoList)
    })
  },
  // ticket登录
  loginValidate({ commit }, ticket) {
    return new Promise((resolve, reject) => {
      loginValidate({
        ticket,
      })
        .then(({ data }) => {
          localStorage.iolcode = data.data.iolCode
          localStorage.token = data.data.token
          localStorage.userInfo = JSON.stringify(data.data)
          commit('changeKey', {
            userInfo: data.data,
          })

          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  // 退出登录
  logout({ commit }, ticket) {
    return new Promise((resolve, reject) => {
      logout()
        .then(({ data }) => {
          localStorage.clear()
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  // 验证token是否过期
  checkToken({ commit }) {
    return new Promise((resolve, reject) => {
      checkToken()
        .then(({ data }) => {
          const res = data.data
          resolve(res)
          const obj = {
            ...state.userInfo,
            profilePhoto: res.profilePhoto,
            email: res.email,
            phone: res.phone,
            casId: res.casId,
            nickName: res.nickname,
            accountType: res.accountType,
          }
          commit('changeKey', {
            userInfo: {
              ...state.userInfo,
              profilePhoto: res.profilePhoto,
              email: res.email,
              phone: res.phone,
              casId: res.casId,
              nickName: res.nickname,
              accountType: res.accountType,
            },
          })
          localStorage.userInfo = JSON.stringify(obj)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
}
export default { state, getters, mutations, actions }
